export interface TokenResponse {
    date_expired: string
    oauth2_access_token: string
    oauth2_refresh_token: string
    refresh_date_expired: string
}

export enum GrantType {
    PASSWORD = 'password',
    REFRESH_TOKEN = 'refresh_token',
    TOKEN = 'token',
    CLIENT_CREDENTIALS = 'client_credentials',
    EXTERNAL_TOKEN = 'external_token'
}

export interface GetAnonymousTokenBody {
    client_id: string
    client_secret: string
    grant_type: string
    refresh_token?: string
}
